import {RegistrationStatus} from "../../actions/types";
import {mapValidationErrors} from "../../pages/user/settings/personal-info/personal-info.service";

export function handleAuthApiCall(state: RegistrationState, status: RegistrationStatus, payload: any): void {
    switch (status) {
        case RegistrationStatus.PENDING:
            state.isLoading = true;
            state.errors = {};

            break;
        case RegistrationStatus.FAIL:
            state.isLoading = false;
            state.errors = mapValidationErrors(payload);

            break;
        case RegistrationStatus.SUCCESS:
            state.isLoading = false;

            break;
    }
}

interface RegistrationState {
    isLoading: boolean,
    errors: {[key: string]: string}
}
